import { Location, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';

import { TranslationModule } from '@hdms/shared/feature';
import { URLS } from '@hdms/shared/page-frame/data-access';
import { UserAccountData } from '@hdms/shared/page-frame/types';
import { ButtonModule } from '@hdms/shared/ui-core';

@Component({
  selector: 'shrd-pf-ft-header-registration-button',
  templateUrl: './header-registration-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonModule, TranslationModule, NgIf]
})
export class HeaderRegistrationButtonComponent {
  isVisible: boolean;

  readonly registrationRoute = URLS.accountRegistration;

  private readonly location = inject(Location).path();

  @Input() buttonVariant = 'tertiaryFlyout';

  @Input()
  set userData(data: UserAccountData) {
    this.isVisible = data.isLoggedIn && !data.isRegistered && !this.location.startsWith(this.registrationRoute);
  }
}
